








import Vue from 'vue';
import { mapState } from 'vuex';
import { Art } from '@/shared/models/art';
import ArtList from '@/components/ArtList.vue';

export default Vue.extend({
  components: {
    ArtList,
  },
  computed: {
    ...mapState({
      artListPaintings: (state: any): Art[] =>
        state.totalArt.artList.filter(artItem => artItem.type === 'painting'),
      artListStatues: (state: any): Art[] =>
        state.totalArt.artList.filter(artItem => artItem.type === 'statue'),
    }),
  },
});
